import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
            <div className="lg:col-span-2">
              <Link to="/" className="inline-flex items-center gap-1 mb-5">
                <span className="text-2xl font-bold font-heading text-background-50">
                  爆瓜网
                </span>
                <span className="w-2 h-2 rounded-full bg-primary-500 ml-0.5 mt-1"></span>
              </Link>
              <p className="text-background-50/60 text-sm leading-relaxed mb-6 max-w-sm">
                聚焦吃瓜爆料在线社区，带来网红反差真实爆料与劲爆内容，独家揭秘内幕真相。每日实时更新，做你最值得信赖的吃瓜伙伴。
              </p>
              <form
                id="subscribe"
                className="flex items-center gap-2 max-w-sm"
                data-readdy-form="true"
                action="https://readdy.ai/api/form/d92fkp80sqa2sn3dng20"
                method="POST"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱订阅劲爆推送"
                  className="flex-1 px-4 py-2.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-background-50/40 text-sm outline-none focus:border-primary-500/50 transition-colors duration-200"
                  required
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 cursor-pointer hover:bg-primary-600 transition-colors duration-200 flex-shrink-0"
                  aria-label="订阅"
                >
                  <i className="ri-notification-3-line text-lg"></i>
                </button>
              </form>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold text-sm mb-4">热门分类</h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-background-50/60 text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold text-sm mb-4">快速链接</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-background-50/60 text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap">首页</Link>
                <Link to="/category/dujia-jiemi" className="text-background-50/60 text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap">独家揭秘</Link>
                <Link to="/category/jingbao-neimu" className="text-background-50/60 text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap">劲爆内幕</Link>
                <Link to="/about" className="text-background-50/60 text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold text-sm mb-4">关注我们</h4>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 cursor-pointer transition-colors duration-200" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 cursor-pointer transition-colors duration-200" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 cursor-pointer transition-colors duration-200" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 cursor-pointer transition-colors duration-200" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-50/40 text-xs">
              &copy; {currentYear} 爆瓜网 Baogua.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-background-50/40 text-xs hover:text-background-50/70 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-background-50/40 text-xs hover:text-background-50/70 transition-colors duration-200 whitespace-nowrap">用户协议</a>
              <a href="#" className="text-background-50/40 text-xs hover:text-background-50/70 transition-colors duration-200 whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}